import { combineReducers } from "../../../../Library/Caches/typescript/3.5/node_modules/redux";

export const moodsSets = (state = [], action) => {
    switch (action.type) {
      case "GET_MOOD_SETS_RESPONSE":
        return action.sets;
      default:
        return state;
    }
  };

  export const moods = combineReducers({
    moodsSets
  });